import { Base } from '../base';
import { FormExtend } from './formExtend';
import { FormItem } from './formItem';

export type FormId = Form['_id'];

export interface Form extends Base {
  active: boolean;                               // 有效（最终版本）
  // TODO:
  belongingOrgs: string[];                       // 可见门店
  column: number;                                // 列数
  description: string;                           // 描述
  extend: FormExtend;
  id: string;                                    // 多版本统一ID
  items: FormItem[];
  name: string;                                  // 名称
  public: boolean;                               // 公开
  schema: string;                                // 存储表
  scoreType: string;                             // 统计类型
  spotChecks: number;                            // 题库：抽查道数
  testTime: number;                              // 题库：考试时间
  type: FormType;
  ver: string;                                   // 版本
}

/**
 * 表单类型
 */
export enum FormType {
  /**
   * 扫码问卷
   */
  QUESTION = '1',
  /**
   * APP巡店
   */
  CHECK = '2',
  /**
   * 考试题库
   */
  ANSWER = '3',
  /**
   * 奖罚赔单
   */
  TICKET = '4',
}
